import React from "react";

function index(props) {
  return (
    <React.Fragment>
      <span className="custom-loader"></span>
    </React.Fragment>
  );
}

export default index;



// WEBPACK FOOTER //
// ./src/components/ButtonLoader/index.js